import { useEffect, useState } from "react";

/**
 * useIsMobile
 *
 * Returns `true` when the viewport width is at or below the given breakpoint.
 * Defaults to 768px (Tailwind's md breakpoint). SSR safe: starts as `false`,
 * updates on mount and on resize.
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
